import { COUNTRY } from '../../../utils/constants'
import { defaultValues } from './json/common.json'

export const APP_CONFIG = {
  appCode: 'RWS',
  appVersion: '1.3.3',
  appName: 'Roof to Wall Selector',
  logoUrl: 'assets/images/rws/rws-logo.svg',
  inversedLogoUrl: 'https://ssttoolbox.widen.net/content/jkqe1osjbe/svg/RWS_Logo_About.svg',
  gaEventName: 'RWS_Events',
  downloadFileName: 'RWS-DATA',
  productThemeClasses: '-themeConnectors',
  navigationConfig: {
    showTutorial: true,
  },
}

/** PRELOADED STATE */
export const APP_STATE_KEY = `sst_bp_${APP_CONFIG.appCode}_app-state`

export const DEFAULT_SETTINGS_STATE = {
  country: COUNTRY.USA,
  isUSA: true,
}

export const APPLICATION_TYPES = {
  PERPENDICULAR_TO_WALL: 'Perpendicular_To_Wall',
  ANGLE_TO_WALL: 'Angle_To_Wall',
  PARALLEL_TO_WALL: 'Parallel_To_Wall',
  CORNER_END_WALL: 'Corner_End_Wall',
}

export const APPLICATION_TYPES_VALUE = {
  PERPENDICULAR_TO_WALL: 0,
  ANGLE_TO_WALL: 1,
  PARALLEL_TO_WALL: 2,
  CORNER_END_WALL: 3,
}

export const DEFAULT_JOBSETTINGS_STATE =
  defaultValues.jobSettings[APPLICATION_TYPES.PERPENDICULAR_TO_WALL].usa

export const MEMBER_TYPES = {
  STUD: 'stud',
  SOLID_SAWN: 'solidSawn',
  TRUSS: 'truss',
  GLULAM: 'glulam',
  IJOIST: 'ijoist',
  LVL: 'lvl',
  LSL: 'lsl',
  PSL: 'psl',
  CONCRETE: 'concrete',
  MASONRY: 'masonry',
}

export const SSTHT_WALL = {
  NONE: 0,
  STUD_DF: 1,
  STUD_HF: 2,
  STUD_SP: 3,
  STUD_SPF: 4,
  CONCRETE: 9,
  MASONRY: 10,
}

export const SSTHT_RAFTER = {
  SAWN_DF: 1,
  SAWN_HF: 2,
  SAWN_SP: 3,
  SAWN_SPF: 4,
  TRUSS_DF: 5,
  TRUSS_HF: 6,
  TRUSS_SP: 7,
  TRUSS_SPF: 8,
  IJOIST_DF: 9,
  LVL_DFSP: 10,
  LSL: 11,
  PSL: 12,
  IJOIST_SPF: 13,
  LVL_SPF: 14,
  GLULAM_SPF: 15,
}

export const STUD_ALIGNMENT_RANGE = {
  STEP: 1,
  MIN: -8,
  MAX: 8,
}

export const STUD_ALIGNMENT_MARKS = [
  {
    value: STUD_ALIGNMENT_RANGE.MIN,
    label: STUD_ALIGNMENT_RANGE.MIN,
  },
  {
    value: 0,
    label: 0,
  },
  {
    value: STUD_ALIGNMENT_RANGE.MAX,
    label: STUD_ALIGNMENT_RANGE.MAX,
  },
]

export const ROOF_MEMBER_TYPES = {
  TRUSS: 'truss',
  RAFTER: 'rafter',
  IJOIST: 'ijoist',
}

export const BUILDING_CODE = {
  usa: 22,
  canada: 42,
}

export const UPDATE_INPUT_ERROR_ACTION = 'updateInputErrors'

export const MESH_MEMBERS = {
  WALL: 'wallMesh',
  ROOF: 'roofMesh',
  DIMENSIONS: 'dimensionsMesh',
  CONNECTORS: 'connectorsMesh',
}

export const HEEL_TOLERANCE = 0.005
export const REQUEST_ABORTED_CODE = 103
export const MIN_RAFTER_HEEL = 3.5

export const SLICE_NAME = {
  SETTINGS: 'settings',
  JOB_SETTINGS: 'jobSettings',
  WALL: 'wall',
  ROOF: 'roof',
}

export const CORROSION_RESISTANCE_VALUE = {
  ALL: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  SEVERE: 4,
}

export const OVERHANG_LENGTH = 3.5
export const IJOIST_INPUT_MANUALLY_DEFAULT_WIDTH = 2.5
export const IJOIST_INPUT_MANUALLY_DEFAULT_THICKNESS = 1.5
